export const userActionDataAttributeParsed = 'faroUserActionName';
export const userActionDataAttribute = 'data-faro-user-action-name';
export const userActionTimeoutDataAttribute: string = userActionDataAttribute.replace(/-name$/, '-timeout');
export const defaultInitialActivityTimeout = 100;
export const maxInitialActivityTimeout = 1000;

export {
  MESSAGE_TYPE_DOM_MUTATION,
  MESSAGE_TYPE_HTTP_REQUEST_START,
  MESSAGE_TYPE_HTTP_REQUEST_END,
} from '../_internal/monitors/const';
